// src/services/cardInitializer.js
import { cardRegistry } from './cardRegistry';
import { registerCardsLazy } from './lazyCardDefinitions';

let initializationPromise = null;

/**
 * Initialize the card registry lazily with authentication check
 * @param {boolean} isAuthenticated - Whether the user is authenticated
 * @param {Array} permittedCardIds - Array of card IDs the user has permission to view
 * @returns {Promise<void>}
 */
export async function initializeCards(isAuthenticated, permittedCardIds = []) {
  if (!isAuthenticated) return;

  if (cardRegistry.isInitialized() && cardRegistry.getAllCards().length === 0) {
    cardRegistry.clear();
  } else if (cardRegistry.isInitialized() && cardRegistry.getAllCards().length > 0) {
    return;
  }

  if (initializationPromise) {
    return initializationPromise;
  }

  initializationPromise = (async () => {
    try {
      registerCardsLazy(permittedCardIds);

      cardRegistry.setInitialized();
    } catch (error) {
      console.error("[CardInitializer] Error registering cards:", error);
      throw error;
    } finally {
      initializationPromise = null;
    }
  })();

  return initializationPromise;
}

/**
 * Reset the card registry (useful for logout)
 */
export function resetCardRegistry() {
  if (cardRegistry.isInitialized() && typeof cardRegistry.clear === 'function') {
    cardRegistry.clear();
  }
  initializationPromise = null;
}